import React, { Component } from 'react';
import Select from 'react-select';
import { iconForField } from '../../common/custom/icon-library';

export default class CollectionSelect extends Component {
  handleChange = values => {
    this.props.onChange('collectionId', values.value);
  };

  render() {
    const options = this.props.options();

    const colourStyles = {
      control: styles => ({ ...styles, backgroundColor: '#fff' }),
      option: (styles, { isDisabled, isFocused, isSelected }) => {
        return {
          ...styles,
          fontSize: '0.875rem',
          color: isDisabled ? null : isSelected ? 'white' : isFocused ? 'white' : null,
          backgroundColor: isDisabled
            ? null
            : isSelected
            ? '#1ba7ae'
            : isFocused
            ? '#1ba7ae9c'
            : null,

          ':active': {
            ...styles[':active'],
            backgroundColor: !isDisabled && (isSelected ? '#fff' : '#1ba7ae'),
          },
        };
      },
    };

    return (
      <div className="form-group">
        <div className="input-group">
          <div className="input-group-prepend" title="Bind Collection">
            <span className="input-group-text">
              <i className={`wb ${iconForField('select')}`}></i>
            </span>
          </div>
          <Select
            className="custom-select-container"
            classNamePrefix="custom-select"
            options={options}
            onChange={this.handleChange}
            value={options ? options.find(option => option.value === this.props.value) : ''}
            styles={colourStyles}
            placeholder="Bind Collection"
          />
        </div>
      </div>
    );
  }
}
